// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","FilterLinks__link":"cb_a bhe_h bhe_ka bhe_ux bhe_ro bhe_un bhe_rq bhe_rh"};